import { useHeightContainer } from 'components/Dashboard/utilities/useHeightContainer';
import { FilterItem } from './CommonFilter';
import ToggleFilter from './ToggleFilter';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useCollapse } from 'react-collapsed';
import normalize from 'components/Dashboard/utilities/normalizeString';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import FilterRegisterPopup from './FilterRegisterPopup';
import { useAuth0 } from '@auth0/auth0-react';
import { store } from 'components/Store';
import CreateAccountPopup from 'components/Dashboard/components/CreateAccountPopup';
import { useMainSectionParameter } from 'components/Dashboard/helpers/useMainSectionParameter';
import ResearchPopUp from 'components/Dashboard/SubNav/ui/ResearchPopUp';
import ReferenceTopicWidget from 'components/Dashboard/SubNav/ReferenceTopicsWidget';
import MembershipSelectFilter from './MembershipSelectFilter';
import useTopicOrClientWord from 'components/Dashboard/hooks/useTopicOrClientWord';
import { filterFiltersOptionDependOnLocation } from 'components/Dashboard/Filters/filterFiltersOptionDependOnLocation';
import CustomScrollbar from 'components/Common/CustomScrollbar';
import { useLocation, useParams } from 'react-router';
import { useFilters } from 'components/Dashboard/Filters/FiltersContext';
import { SpecificViewElement } from 'components/Dashboard/KeyUpdates/ShowRelevantExtract';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import { sectionName } from 'components/Dashboard/helpers/controlActiveFilters';
import SelectFilter from 'components/Dashboard/Filters/ui/SelectFilter';
import FilterTypeRenderer from './FilterTypeRenderer';
import SeparateOutsideFilters from 'components/Dashboard/Filters/ui/SeparateOutsideFilters';

const OutsideFilters = (props) => {
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { activePlan, search, referenceState, keywordsLists, readyKeywordLists, openResearchPopup } = state;

  const { activeSearch, list } = search;
  const { activeReference } = referenceState;
  const { subscriptionStatus, code, enableReferenceSection } = activePlan;
  const { section, hideFiltersQntty, useInDropdown } = props;
  const filtersContext = useFilters();
  const { getDefaultSectionFilters, filtersState, applyFiltersFunction, filterTypeModifiers, clearOneSingleFilter } =
    filtersContext;
  const searchMode = activeSearch || activeReference;

  const [heightContainer, containerRef] = useHeightContainer();
  const [heightContainerInsideBox, containerRefInsideBox] = useHeightContainer();

  const sectionFilters = getDefaultSectionFilters(filtersState);
  const [showRegisterPopup, setShowRegisterPopup] = useState(false);

  const { isAuthenticated } = useAuth0();
  const location = useLocation();
  const params = useParams();

  const { searchResultsSection, inboxSection, priorityUpdatesSection } = useMainSectionParameter(params);

  const trialUser =
    (subscriptionStatus === 'InTrial' && code.includes('Mogul')) ||
    subscriptionStatus === 'TrialEnded' ||
    !enableReferenceSection;
  const allowedUsers = (isAuthenticated && !trialUser) || inboxSection;
  const selectOption = () => {
    return ({ filter, newValue }) => {
      if (allowedUsers) {
        let newFilters = filterTypeModifiers({ filter, newValue });
        applyFiltersFunction(newFilters);
      } else {
        setShowRegisterPopup(true);
      }
    };
  };

  const updateScrollBarPosition = useRef(null);
  const scrollBarRef = useRef(null);
  updateScrollBarPosition.current = () => {
    scrollBarRef.current.scrollToLeft();
    scrollBarRef.current.scrollToTop();
  };

  useEffect(() => {
    updateScrollBarPosition.current();
  }, [list, location.pathname]);

  useEffect(() => {
    if (!activeReference) {
      updateScrollBarPosition.current();
    }
  }, [activeReference]);

  //REFERENCE ELEMENTS NEW WIDGET ON THE OUTSIDE FILTERS
  const [showPopup, setShowPopup] = useState(false);
  const [keywordsSection, setKeywordsSection] = useState('keywords');

  const showPopupFromEmptyMessage = useRef(null);
  showPopupFromEmptyMessage.current = () => {
    if (openResearchPopup) {
      setShowPopup(true);
      dispatch({
        type: 'MODIFY_SECTION',
        parameter: 'openResearchPopup',
        value: false,
      });
    }
  };
  useEffect(() => {
    showPopupFromEmptyMessage.current();
  }, [openResearchPopup]);

  const closeKeywordsSection = () => {
    setKeywordsSection('keywords');
  };

  const relevantExtractCondition = location.pathname?.includes('/key-updates') || priorityUpdatesSection;
  const parliamentLiveViewCondition =
    location.pathname?.includes('/parliament-live') &&
    (inboxSection || (searchResultsSection && getUrlParam('search')));
  const sectionViewCondition = (!useInDropdown && relevantExtractCondition) || parliamentLiveViewCondition;
  const separateFiltersCondition = sectionFilters.filter((item) => item.separateFilter)?.length > 0;

  return (
    <>
      <div ref={containerRef} className={`outside-filters reference-main-content ${normalize(sectionName())}`}>
        <div
          className={
            sectionViewCondition || separateFiltersCondition
              ? ''
              : `${useInDropdown ? '' : 'outside-filters-around-container'}`
          }
        >
          <CustomScrollbar
            className={'main-content-scrollbar top-content-scrollbar'}
            style={{ height: `${heightContainer}px` }}
            maximalThumbYSize={100}
            ref={scrollBarRef}
          >
            <SeparateOutsideFilters
              section={section}
              hideFiltersQntty={hideFiltersQntty}
              filtersContext={filtersContext}
            />
            {sectionViewCondition && (
              <SpecificViewElement viewName={relevantExtractCondition ? 'Snippet displayed' : 'View'} />
            )}
            <div className={sectionViewCondition || separateFiltersCondition ? `outside-filters-around-container` : ''}>
              <div
                ref={containerRefInsideBox}
                className='outside-filters-box'
                style={{ minHeight: `${heightContainerInsideBox}px` }}
              >
                {searchResultsSection && readyKeywordLists && (
                  <div className='outside-filters-spacing-container py-4 border-bottom'>
                    <ReferenceTopicWidget
                      keywordsLists={keywordsLists}
                      setShowPopup={setShowPopup}
                      keywordsSection={keywordsSection}
                      setKeywordsSection={setKeywordsSection}
                    />
                  </div>
                )}
                <div className='outside-filters-spacing-container'>
                  {sectionFilters
                    .filter((item) => !item.excludeFromPopup && !item.separateFilter)
                    .slice(hideFiltersQntty ? hideFiltersQntty + 1 : 0, undefined)
                    .map((item, index) => {
                      const { hidden, name } = item;
                      const showFilter = !hidden;
                      const renderFilter = showFilter;
                      const filteredOptionsItem = filterFiltersOptionDependOnLocation({
                        item,
                        filters: sectionFilters,
                      });
                      const filterProps = {
                        filter: filteredOptionsItem,
                        selectOption: selectOption(),
                      };
                      return (
                        <React.Fragment key={`section-filter-${index}-${normalize(name)}`}>
                          {renderFilter && (
                            <OutsideFilter
                              {...filterProps}
                              sectionFilters={sectionFilters}
                              section={section}
                              allowedUsers={allowedUsers}
                              searchMode={searchMode}
                              clearOneSingleFilter={clearOneSingleFilter}
                            />
                          )}
                        </React.Fragment>
                      );
                    })}
                </div>
              </div>
            </div>
          </CustomScrollbar>
        </div>
      </div>
      <FilterRegisterPopup
        setShowPopup={setShowRegisterPopup}
        proMessage={!enableReferenceSection && isAuthenticated}
        showPopup={showRegisterPopup && isAuthenticated}
      />
      {!isAuthenticated && (
        <CreateAccountPopup
          text={'You’ll need to create an account to filter results'}
          setShowPopup={setShowRegisterPopup}
          showPopup={showRegisterPopup}
        />
      )}
      <ResearchPopUp
        keywordsLists={keywordsLists.filter((item) => item.id !== null)}
        setShowPopup={setShowPopup}
        showPopUp={showPopup}
        additionalCloseAction={closeKeywordsSection}
        keywordsSection={keywordsSection}
        referenceState={referenceState}
      />
    </>
  );
};

const OutsideFilter = (props) => {
  const location = useLocation();
  const { filter, list, clearOneSingleFilter, allowedUsers } = props;
  const {
    name,
    type,
    optionSelected,
    value,
    options,
    disabled,
    subtextClassName,
    notExpand,
    label,
    lockMessage,
    emptyOptionName,
  } = filter;
  const expandedConditional = () => {
    const stakeholderConditionals =
      location.pathname.includes('/stakeholder-mapping') || location.pathname.includes('/policymakers');
    return !stakeholderConditionals;
  };
  const [isExpanded, setExpanded] = useState(expandedConditional());
  const [isExpandedOnAction, setExpandedOnAction] = useState(false);
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded });

  const isMobile = useIsMobile(1280);
  const transformName = () => {
    if (isMobile) {
      switch (name) {
        case 'Exclude closed consultations':
          return 'Exclude closed';
        case 'Search within results':
          return 'Search within';
        default:
          return name;
      }
    }
    return label || name;
  };

  const subtext = () => {
    let text = '';
    if (type === 'search' && value !== '') {
      text = value;
    } else if (!!optionSelected && optionSelected !== emptyOptionName && type !== 'membership') {
      text = optionSelected;
    } else if (!type || type === 'parliamentaryRecordMultipleHierarchy' || type === 'membership') {
      text = options
        .filter((option) => option.selected)
        .flatMap((option) =>
          option.optionSelected && !option.optionSelected.includes('All') ? option.optionSelected : option.name
        )
        .join(', ');
    }
    return text;
  };

  const clearIndividualFilter = () => {
    clearOneSingleFilter({ filter });
    setExpanded(true);
  };
  const { agencyUser } = useTopicOrClientWord();

  return (
    <div className={`popup-outside-filter-container`}>
      {type !== 'toggle' && (
        <>
          <div
            className={notExpand ? 'default-cursor' : ''}
            {...getToggleProps({
              onClick: () => {
                if (!disabled && !notExpand) {
                  setExpanded((prevExpanded) => !prevExpanded);
                  setExpandedOnAction(!isExpanded);
                }
              },
            })}
          >
            <h3
              className={`mb-0 title-h5-bold ${notExpand ? '' : 'dropdown-item-element'} d-block ${
                isExpanded ? 'open' : ''
              } ${disabled ? 'main-light-text' : ''}`}
            >
              {transformName()}
              {disabled && (
                <span
                  className='ml-2 icon-padlock d-inline-block'
                  data-tooltip-html={
                    lockMessage || `Upgrade to ${agencyUser ? '' : 'Mogul or '}Enterprise for sentiment analysis`
                  }
                  data-tooltip-id={'general-tooltip'}
                />
              )}
            </h3>
            {!isExpanded && subtext() !== '' && (
              <p className='mb-0 paragraph-p2 main-light-text outside-filter-subtext'>
                <span className={subtextClassName ? `${subtextClassName} ${normalize(optionSelected)}` : ''}>
                  {subtext()}
                </span>
                {type !== 'sort' && type !== 'sortMode' && (
                  <button
                    className='general-button action-delete-text d-inline-block ml-2'
                    onClick={(e) => {
                      e.stopPropagation();
                      clearIndividualFilter();
                    }}
                  >
                    Clear
                  </button>
                )}
              </p>
            )}
          </div>
          <div {...getCollapseProps()}>
            <div className={`pt-${type === 'sort' || type === 'date' ? 3 : 4} outside-collapsing-options`}>
              <FilterTypeRenderer
                filterProps={props}
                type={type}
                allowedUsers={allowedUsers}
                list={list}
                isExpandedOnAction={isExpandedOnAction}
                setExpanded={setExpanded}
                showMoreOptions={true}
              />
            </div>
          </div>
        </>
      )}
      {type === 'toggle' && <ToggleFilter {...props} />}
    </div>
  );
};

const OutsideSearchFilter = (props) => {
  const { filter, selectOption, isExpanded } = props;
  const { value } = filter;
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    if (isExpanded) {
      setTimeout(() => {
        inputSearchRef.current.focus();
      }, 100);
    }
  }, [isExpanded]);

  const inputSearchRef = useRef(null);
  const updateCurrentValue = useRef(null);
  updateCurrentValue.current = () => {
    if (value !== currentValue) {
      setCurrentValue(value);
    }
  };

  useEffect(() => {
    updateCurrentValue.current();
  }, [value]);

  return (
    <div className='pb-2'>
      <div className='flex-centered box-rounded simple-input-box'>
        <span className='icon-search title-h4 mr-2' style={{ color: '#9c9c9c' }} />
        <div className='flex-grow-1'>
          <input
            ref={inputSearchRef}
            className='search-main-input w-100'
            type='text'
            value={currentValue}
            onChange={(e) => {
              let newValue = e.target.value;
              setCurrentValue(newValue);
            }}
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                selectOption({ filter, newValue: currentValue });
                e.target.blur();
              }
            }}
          />
        </div>
        <div
          className='close-icon-container'
          style={{
            visibility: value !== '' ? 'visible' : 'hidden',
          }}
        >
          <button
            className='general-button close-icon'
            onClick={() => {
              selectOption({ filter, newValue: '' });
              setCurrentValue('');
            }}
          />
        </div>
      </div>
    </div>
  );
};

const OutsideCommonFilter = (props) => {
  const { filter, selectOption, allowedUsers, isExpandedParent, showMoreOptions = true } = props;
  const { options, name, type, subtype } = filter;
  let splitItemValue = 4;

  const changeFilter = (selected, index, name) => {
    let newValue = [...options?.filter((item) => !item.hidden)];
    let currentOption = newValue[index];
    if (allowedUsers) {
      if (name) {
        if (!selected) {
          currentOption.selected = true;
        }
        currentOption.optionSelected = name;
      } else {
        currentOption.selected = selected ? !selected : true;
      }
    }
    selectOption({ filter, newValue });
  };
  const moreOptions = () => {
    let seeMoreOptions = [];
    if ((name === 'Party' || name === 'Region') && showMoreOptions) {
      seeMoreOptions = options.slice(splitItemValue, options.length);
    }
    return seeMoreOptions;
  };

  const optionsToRender = () => {
    if ((name === 'Party' || name === 'Region') && showMoreOptions) {
      return options.slice(0, splitItemValue);
    }
    return options;
  };

  const [isExpanded, setExpanded] = useState(false);
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded });

  return (
    <>
      <div className='common-outside-filter'>
        {type === 'membership' && subtype !== 'Teammates' && subtype !== 'Clients' && (
          <MembershipSelectFilter {...props} notIncludeName isExpanded={isExpandedParent} />
        )}
        {type === 'membership' && (subtype === 'Teammates' || subtype === 'Clients') && (
          <SelectFilter {...props} notIncludeName isExpanded={isExpandedParent} />
        )}
        {optionsToRender()
          .filter((item) => !item.hidden)
          .map((option, index) => (
            <FilterItem
              option={option}
              options={options}
              key={`option-filter${index}`}
              index={index}
              changeFilter={changeFilter}
              notRow
              idPrefix='outside-'
            />
          ))}

        {moreOptions().length > 0 && (
          <>
            <div {...getCollapseProps()}>
              {moreOptions().map((option, index) => (
                <FilterItem
                  option={option}
                  options={options}
                  key={`option-filter${index + splitItemValue}`}
                  index={index + splitItemValue}
                  changeFilter={changeFilter}
                  notRow
                  idPrefix='outside-'
                />
              ))}
            </div>

            <button
              className={`d-inline-block simple-link-button general-button showitem-button ${
                isExpanded ? 'closeitem-button' : ''
              }`}
              {...getToggleProps({
                onClick: () => setExpanded((prevExpanded) => !prevExpanded),
              })}
            >
              Show {isExpanded ? 'less' : 'more'}
            </button>
          </>
        )}
      </div>
    </>
  );
};

export { OutsideCommonFilter, OutsideSearchFilter, OutsideFilter };
export default OutsideFilters;
